import { render, staticRenderFns } from "./AddAlert.vue?vue&type=template&id=dd9e4650&"
import script from "./AddAlert.vue?vue&type=script&lang=js&"
export * from "./AddAlert.vue?vue&type=script&lang=js&"
import style0 from "./AddAlert.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports